import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type DriveState = {
  currentFolderId: string | null;
  selectedItemIds: string[];
};

const initialState: DriveState = {
  currentFolderId: null,
  selectedItemIds: [],
};

const driveSlice = createSlice({
  name: 'drive',
  initialState,
  reducers: {
    setCurrentFolderId: (state, action: PayloadAction<string | null>) => {
      state.currentFolderId = action.payload;
    },
    setSelectedItemIds: (state, action: PayloadAction<string[]>) => {
      state.selectedItemIds = action.payload;
    },
    removeSelectedItemId: (state, action: PayloadAction<string>) => {
      state.selectedItemIds = state.selectedItemIds.filter(id => id !== action.payload);
    },
    clearSelection: state => {
      state.selectedItemIds = [];
    },
    clearDriveState: state => {
      state.currentFolderId = null;
      state.selectedItemIds = [];
    },
  },
});

export const {
  clearDriveState,
  clearSelection,
  removeSelectedItemId,
  setCurrentFolderId,
  setSelectedItemIds,
} = driveSlice.actions;

export default driveSlice.reducer;
